import * as React from 'react';

function SvgTriangleRight(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M18.53 14.53l-7.06-6v12l7.06-6z" fill="#414B56" />
    </svg>
  );
}

export default SvgTriangleRight;
